import React from "react";
import "./App.scss";
import BasicExample from "./Main";
import "@material/react-text-field/dist/text-field.css";
import { connect } from "react-redux";
import "nouislider/distribute/nouislider.css";
import { DetectPartner } from "./detectPartnerUrl";
import ReactGA from "react-ga";
import cookie from "react-cookies";
class App extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  componentDidMount() {
    ReactGA.initialize("UA-150297492-1");
    DetectPartner(window.location.search);

    if (document.getElementById("mobile_patern")) {
      document.getElementById("mobile_patern").style.display = "none";
      if (window.matchMedia("(max-width: 800px)").matches) {
        var hidennav = document.getElementById("mobilenav").offsetLeft;
        if (hidennav === 0) {
          document.getElementById("mobile_patern").style.display = "block";
        } else {
          document.getElementById("mobile_patern").style.display = "none";
        }
      } else {
        document.getElementById("mobile_patern").style.display = "none";
      }
    }

    document.body.onclick = function (e) {
      if (window.matchMedia("(max-width: 800px)").matches) {
        // if(window.matchMedia('(max-width: 768px)').matches) {
        e = window.event;
        var target = e.target || e.srcElement;
        var hidennav = document.getElementById("mobilenav").offsetLeft;
        //Закрытие меню
        if (hidennav === 0) {
          if (!(target.tagName === "A" || target.tagName === "UL")) {
            document.getElementById("mobile_patern").style.display = "none";
            document.getElementsByClassName("hidden-menu")[0].style.left = "-255px";
            document.getElementsByClassName("hidden-menu-ticker")[0].checked = false;
          }
          //Открытие меню
        } else {
          if (
            (target.tagName === "LABEL" && target.className === "btn-menu") ||
            (target.tagName === "SPAN" && target.className === "first") ||
            (target.tagName === "SPAN" && target.className === "second") ||
            (target.tagName === "SPAN" && target.className === "third")
          ) {
            // document.body.style.overflow = "hidden";
            document.getElementById("mobile_patern").style.display = "block";
            document.getElementsByClassName("hidden-menu")[0].style.left = "0px";
          }
        }
      }
    };
  }

  render() {
    return (
      <div>
        <BasicExample />
      </div>
    );
  }
}

export default connect((state) => ({ store: state }))(App);



// WEBPACK FOOTER //
// src/App.js